let theme = {
  primary: "#a6864b",
  textDefault: "#111",
  borderRadiusSm: "6px",
  borderRadius: "8px",
  borderRadiusLg: "10px",
  backgroundDefault: "#fff",
  backgroundPrimary: "#f1eae5",
  backgroundSecondary: "#f4f2ef",
}

export default theme
